import { render } from "./KanbanStatus.vue?vue&type=template&id=5559567a&scoped=true"
import script from "./KanbanStatus.vue?vue&type=script&lang=js"
export * from "./KanbanStatus.vue?vue&type=script&lang=js"

import "./KanbanStatus.vue?vue&type=style&index=0&id=5559567a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5559567a"]])

export default __exports__